import { Button, Meta, theme } from 'aimo-ui';
import AimoPlusIcon from 'components/account/subscription/AimoPlusIcon';
import SubPromotionCard from 'components/account/subscription/SubPromotionCard';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { StyledWrapper } from 'styles/ContainerStyles';
import { Maybe, Scalars } from 'types/generatedSchemaTypes';
import { Row } from '../styles/styles';
import { useUiStore } from 'stores/uiStore';

const StyledSeparatorView = styled.View`
  border-bottom-color: ${(p: any) => p.theme.colors.gray50};
  border-bottom-width: 3px;
  margin-top: 10px;
`;

const FlexContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const Wrapper = styled.View`
  padding: 20px 20px 37px;
  background-color: ${theme.colors.white};
  gap: 11px;
`;

const StyledMeta = styled(Meta)`
  font-weight: bold;
  font-size: 16px;
`;

const WeightedMeta = styled(Meta)`
  font-size: 16px;
`;

const PricingDescription = styled.View`
  margin-top: 10px;
  width: 100%;
`;

const DescMeta = styled(Meta)`
  flex-wrap: wrap;
  color: ${theme.colors.gray300};
`;

type ParkingSessionPriceBreakDownDetailsProps = {
  parkingFee: string;
  serviceFee: string;
  totalPrice: string;
  serviceFeePercent?: Maybe<Scalars['Float']>;
  serviceFeeMin?: string;
  serviceFeeMax?: string;
  showServiceFeePercentInfo: boolean;
  hasCorporateAccount?: boolean;
};

const PriceBreakdownDetails: React.FC<
  ParkingSessionPriceBreakDownDetailsProps
> = ({
  parkingFee,
  serviceFee,
  totalPrice,
  serviceFeePercent,
  serviceFeeMin,
  serviceFeeMax,
  showServiceFeePercentInfo,
  hasCorporateAccount = false,
}) => {
  const { t } = useTranslation();
  const handleBack = () => {
    useUiStore.getState().setSheetModal('');
  };
  const noServiceFee = serviceFee.includes(t('price.noPrice'));
  return (
    <StyledWrapper mb={12}>
      <FlexContainer>
        <WeightedMeta>{t('parking.receipt.parkingFee')}</WeightedMeta>
        <WeightedMeta>{parkingFee}</WeightedMeta>
      </FlexContainer>
      <FlexContainer>
        <WeightedMeta>{t('parking.receipt.serviceFee')}</WeightedMeta>
        <Row>
          {!noServiceFee && (
            <AimoPlusIcon hasCorporateAccount={hasCorporateAccount} />
          )}
          <WeightedMeta>{serviceFee}</WeightedMeta>
        </Row>
      </FlexContainer>
      <StyledSeparatorView />
      {showServiceFeePercentInfo ? (
        <>
          <FlexContainer>
            <StyledMeta>{t('parking.receipt.totalPrice')}</StyledMeta>
            <StyledMeta>{totalPrice}</StyledMeta>
          </FlexContainer>
          <View style={{ marginBottom: 40 }}>
            <StyledSeparatorView />
            <PricingDescription>
              <DescMeta>
                {t('price.serviceFeePriceBreakdownDesc', {
                  percent: serviceFeePercent,
                  min: serviceFeeMin,
                  max: serviceFeeMax,
                })}
              </DescMeta>
            </PricingDescription>
          </View>
        </>
      ) : (
        <FlexContainer style={{ marginBottom: 40 }}>
          <StyledMeta>{t('parking.receipt.totalPrice')}</StyledMeta>
          <StyledMeta>{totalPrice}</StyledMeta>
        </FlexContainer>
      )}
      <SubPromotionCard />
      <Button
        text={t('button.close')}
        size="l"
        testID="close"
        onPress={handleBack}
      />
    </StyledWrapper>
  );
};

export default PriceBreakdownDetails;
